var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { i18n } from '@easydata/core';
import { utils as dataUtils } from '@easydata/core';
import { DataKind } from '@easyquery/core';
import { domel } from '@easydata/ui';
import { ExpressionRenderer } from './expression_renderer';
import { QPEditablePart } from '../../../types/qp_editable_part';
import { browserUtils } from '../../../utils/browser_utils';
var InputExpressionRenderer = /** @class */ (function (_super) {
    __extends(InputExpressionRenderer, _super);
    function InputExpressionRenderer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    InputExpressionRenderer.prototype.renderEditor = function () {
        var _this = this;
        this.inputBuilder = domel("input")
            .hide()
            .addClass(this.cssPrefix + "-ve-editbox")
            .type('text')
            .on('blur', function (ev) {
            if (_this.inputBuilder.isVisible() && !_this.dontProcessBlur) {
                var validationResult = _this.validateInput(_this.inputElement.value);
                if (validationResult.success) {
                    _this.setValue(_this.inputElement.value);
                    _this.closeEditor();
                }
                else {
                    _this.dontProcessBlur = true;
                    _this.inputElement.focus();
                    setTimeout(function () { _this.dontProcessBlur = false; }, 200);
                    _this.showValidationError(validationResult.message, ev.target);
                }
                ev.stopPropagation();
                return false;
            }
        })
            .on('keydown', function (ev) {
            if (ev.keyCode === 27) { // ESC is pressed
                _this.closeEditor();
                ev.stopPropagation();
                return false;
            }
            else if (ev.keyCode === 13) { // Enter is pressed
                if (_this.inputBuilder.isVisible()) {
                    _this.dontProcessBlur = true;
                    var validationResult = _this.validateInput(_this.inputElement.value);
                    if (validationResult.success) {
                        _this.setValue(_this.inputElement.value);
                        _this.closeEditor();
                        _this.dontProcessBlur = false;
                    }
                    else {
                        _this.inputElement.focus();
                        _this.showValidationError(validationResult.message, ev.target);
                        setTimeout(function () { _this.dontProcessBlur = false; }, 200);
                    }
                    ev.stopPropagation();
                    return false;
                }
            }
        });
        this.inputElement = this.inputBuilder.toDOM();
        domel(this.element)
            .addChildElement(this.inputElement);
    };
    InputExpressionRenderer.prototype.showEditor = function () {
        var MIN_WIDTH = 200;
        if (!browserUtils.isMobileMode()) {
            var left = this.element.offsetLeft;
            var width = this.element.offsetWidth > MIN_WIDTH ? this.element.offsetWidth : MIN_WIDTH;
            var maxWidth = this.element.parentElement.clientWidth - left - 55;
            this.inputBuilder
                .removeStyle('left')
                .removeStyle('right');
            if (maxWidth < MIN_WIDTH) {
                this.inputBuilder
                    .setStyle('right', '55px')
                    .setStyle('width', MIN_WIDTH + "px");
            }
            else if (maxWidth < width) {
                this.inputBuilder
                    .setStyle('left', left + "px")
                    .setStyle('width', maxWidth + "px");
            }
            else {
                this.inputBuilder
                    .setStyle('left', left + "px")
                    .setStyle('width', width + "px");
            }
        }
        domel(this.labelElement).hide();
        this.inputBuilder
            .value(this.getValue())
            .show();
        this.inputElement.focus();
    };
    InputExpressionRenderer.prototype.closeEditor = function () {
        this.inputBuilder.hide();
        domel(this.labelElement).show();
        this.labelElement.focus();
    };
    InputExpressionRenderer.prototype.validateInput = function (inputValue) {
        this.inputBuilder.removeClass("eqjs-invalid");
        var result = {
            success: true,
            value: inputValue
        };
        if (this.expression.kind == DataKind.List) {
            this.validateListInput(inputValue, result);
        }
        else {
            this.validateScalarInput(inputValue, result);
        }
        return result;
    };
    InputExpressionRenderer.prototype.validateListInput = function (inputValue, result) {
        var inputValues = inputValue.split(/\s*,\s*/);
        for (var _i = 0, inputValues_1 = inputValues; _i < inputValues_1.length; _i++) {
            var val = inputValues_1[_i];
            this.validateScalarInput(val, result);
            if (!result.success) {
                return;
            }
        }
    };
    InputExpressionRenderer.prototype.validateScalarInput = function (inputValue, result) {
        if (!inputValue)
            return;
        if (dataUtils.isNumericType(this.expression.dataType)) {
            var parsedVal = +inputValue;
            if (isNaN(parsedVal)) {
                result.success = false;
                result.message = '"' + inputValue + '" ' + i18n.getText('ErrNotNumber');
            }
            if (dataUtils.isIntType(this.expression.dataType) && parsedVal != parseInt(inputValue, 10)) {
                result.success = false;
                result.message = '"' + inputValue + '" ' + i18n.getText('ErrIncorrectInteger');
            }
        }
    };
    InputExpressionRenderer.prototype.showValidationError = function (message, target) {
        _super.prototype.showValidationError.call(this, message, target);
        this.inputBuilder.addClass("eqjs-invalid");
    };
    InputExpressionRenderer.prototype.isEditable = function () {
        return _super.prototype.isEditable.call(this)
            && ((this.panel.options.editableParts & QPEditablePart.Value) === QPEditablePart.Value);
    };
    return InputExpressionRenderer;
}(ExpressionRenderer));
export { InputExpressionRenderer };
//# sourceMappingURL=input_expression_renderer.js.map